import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function SpringIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <g clipPath="url(#clip0_10640_68245)">
        <path
          d="M21.8348 1.24555C21.4986 2.05193 21.0683 2.81574 20.5528 3.52105C18.2942 1.26372 15.2317 -0.00449495 12.0384 -0.00488281C5.4345 -0.00488281 1.11576e-08 5.43412 1.11576e-08 12.0454C-7.02137e-05 13.6779 0.33135 15.2935 0.974176 16.7942C1.617 18.2949 2.55785 19.6494 3.73969 20.7757L4.18369 21.1695C6.35361 22.999 9.10006 24.0032 11.9383 24.0049C18.2171 24.0049 23.4953 19.0849 23.9423 12.8143C24.2706 9.74474 23.3702 5.86237 21.8348 1.24555ZM5.45006 20.8444C5.3534 20.9635 5.23139 21.0595 5.09292 21.1255C4.95445 21.1914 4.80301 21.2257 4.64963 21.2257C4.08375 21.2257 3.62081 20.76 3.62081 20.1941C3.62081 19.6284 4.08675 19.1627 4.64963 19.1627C4.884 19.1627 5.11556 19.2439 5.29688 19.3941C5.73769 19.7503 5.8065 20.4036 5.45006 20.8444ZM21.7849 17.2372C18.8143 21.1976 12.4699 19.8628 8.40188 20.0535C8.40188 20.0535 7.67963 20.0974 6.95419 20.2161C6.95419 20.2161 7.22606 20.1004 7.5795 19.9659C10.4344 18.972 11.7851 18.7781 13.5204 17.8873C16.788 16.2244 20.0181 12.5859 20.6904 8.80049C19.446 12.4421 15.6748 15.5711 12.2385 16.8433C9.88406 17.7124 5.63138 18.5563 5.63138 18.5563L5.45944 18.4656C2.56406 17.0559 2.47631 10.7824 7.73887 8.7568C10.0434 7.86899 12.2479 8.35668 14.7369 7.76268C17.3948 7.13137 20.4684 5.13693 21.7191 2.5363C23.1199 6.69693 24.8055 13.2111 21.7849 17.2372Z"
          fill="#77BC1F"
        />
      </g>
      <defs>
        <clipPath id="clip0_10640_68245">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
